import { AxnCompany, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { FormattedWorkflowConfiguration, WorkflowConfiguration } from "@idw-types/data/workflow-configuration/workflow-configuration";
import { isAllowedToRestore } from "@utils/data-util";

export const formatWorkflowConfigurations = (
    workflowConfigurations: Array<WorkflowConfiguration>,
    companies: Array<AxnCompany>,
    relyingParties: Array<AxnRelyingParty>
): Array<FormattedWorkflowConfiguration> => {
    return workflowConfigurations.map(workflowConfiguration => {
        const company = companies.find(c => c.id === workflowConfiguration.companyID);
        const relyingParty = relyingParties.find(rp => rp.id === workflowConfiguration.relyingPartyID);
        return formatWorkflowConfiguration(workflowConfiguration, company, relyingParty);
    });
};

export const formatWorkflowConfiguration = (
    workflowConfiguration: WorkflowConfiguration,
    company: AxnCompany,
    relyingParty: AxnRelyingParty
): FormattedWorkflowConfiguration => {
    let lastModifiedDate = null;
    if (workflowConfiguration.lastModifiedDate) {
        lastModifiedDate = new Date(parseInt(workflowConfiguration.lastModifiedDate));
    }

    let lastDeploymentDate = null;
    if (workflowConfiguration.lastDeploymentDate) {
        lastDeploymentDate = new Date(parseInt(workflowConfiguration.lastDeploymentDate));
    }

    return {
        apiKeys: workflowConfiguration.apiKeys,
        changeRequestID: workflowConfiguration.changeRequestID,
        changeRequestStatus: workflowConfiguration.changeRequestStatus,
        changeRequestType: workflowConfiguration.changeRequestType,
        company: company,
        id: workflowConfiguration.id,
        lastDeploymentDate,
        lastModifiedDate,
        name: workflowConfiguration.name,
        permissions: {
            ...workflowConfiguration.permissions,
            canRestore: isAllowedToRestore(
                workflowConfiguration.permissions.canRestore,
                relyingParty.status,
                company.status
            )
        },
        primaryAPKey: workflowConfiguration.primaryAPKey,
        primaryRPServiceID: workflowConfiguration.primaryRPServiceID,
        relyingParty: relyingParty,
        rpServiceIDs: workflowConfiguration.rpServiceIDs,
        sku: workflowConfiguration.sku,
        status: workflowConfiguration.status,
        workflowKey: workflowConfiguration.workflowKey
    };
};